module.exports = __webpack_public_path__ + "img/forward-fill.e5218b8f.svg";